import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "site-header" }
const _hoisted_3 = { class: "header-inner" }
const _hoisted_4 = {
  class: "desktop-nav",
  "aria-label": "Main navigation"
}
const _hoisted_5 = ["aria-expanded"]
const _hoisted_6 = { class: "site-main" }
const _hoisted_7 = { class: "content-wrapper" }
const _hoisted_8 = { class: "site-footer" }
const _hoisted_9 = { class: "footer-inner" }

import { ref, computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const menuOpen = ref(false);
const currentYear = computed(() => new Date().getFullYear());

function toggleMenu() {
  menuOpen.value = !menuOpen.value;
}

function closeMenu() {
  menuOpen.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "logo-bracket" }, "<", -1),
            _createTextVNode("KonH", -1),
            _createElementVNode("span", { class: "logo-bracket" }, " />", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("nav", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/skills" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Skills", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/work" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Work", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/projects" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Projects", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/pull_requests" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Pull Requests", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/blog" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Blog", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/contacts" }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Contacts", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("button", {
          class: "menu-toggle",
          "aria-expanded": menuOpen.value.toString(),
          "aria-label": "Toggle navigation",
          onClick: toggleMenu
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["bar", { open: menuOpen.value }])
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass(["bar", { open: menuOpen.value }])
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass(["bar", { open: menuOpen.value }])
          }, null, 2)
        ], 8, _hoisted_5)
      ]),
      _createElementVNode("nav", {
        class: _normalizeClass(["mobile-nav", { open: menuOpen.value }]),
        "aria-label": "Mobile navigation"
      }, [
        _createVNode(_component_router_link, {
          to: "/",
          onClick: closeMenu
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("Home", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/skills",
          onClick: closeMenu
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode("Skills", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/work",
          onClick: closeMenu
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("Work", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/projects",
          onClick: closeMenu
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("Projects", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/pull_requests",
          onClick: closeMenu
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode("Pull Requests", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/blog",
          onClick: closeMenu
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode("Blog", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/contacts",
          onClick: closeMenu
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode("Contacts", -1)
          ]))]),
          _: 1
        })
      ], 2)
    ]),
    _createElementVNode("main", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createElementVNode("footer", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", null, "© " + _toDisplayString(currentYear.value) + " Konstantin Khitrykh", 1),
        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "sep" }, "·", -1)),
        _cache[16] || (_cache[16] = _createElementVNode("a", {
          href: "https://github.com/KonH/konh.github.io",
          target: "_blank"
        }, "Source", -1)),
        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "sep" }, "·", -1)),
        _cache[18] || (_cache[18] = _createElementVNode("span", null, "Built with Vue 3", -1))
      ])
    ])
  ]))
}
}

})